---
fr:
  market_outlook:
    duration: Courbe de durée
    forward_contracts: Contrats à terme
    futures_prices_ytd: Prix à terme YTD
    heading: Aperçu du marché
    high: P95
    info_text: Le fichier Excel contient toutes les zones de prix, pas seulement celles sélectionnées.
    lowerq: Premier quartile inférieur
    median: Médiane
    minimum: P5
    nasim: Il n'est pas possible de simuler les prix pour la zone de prix pour le moment
    pfc: Courbe des prix à terme
    pfc_table: Tableau des prix à terme
    simulations: Simulations de prix
    spot_prices_ytd: Prix de l'électricité YTD
    upperq: Premier quartile supérieur
